<template>
  <button
    class="product-item"
    :class="{ hover }"
    @click.stop="click"
    @mouseenter="mouseenter"
    @mouseleave="mouseleave"
  >
    <img :src="item.picture" />
    <div class="container-info">
      <h5>{{ item.name }}</h5>

      <hr />

      <div class="d-flex align-items-center mb-2">
        <i class="icon-rating"></i><span class="font-weight-bold">5</span>
        <i class="icon-products"></i><span class="font-weight-bold">30%</span>
      </div>

      <div class="d-flex justify-content-between">
        <span>Preço máximo</span>
        <strong>R$ 87,50</strong>
      </div>
      <div class="d-flex justify-content-between">
        <span>Comissão até</span>
        <strong class="text-success">R$ 10,50</strong>
      </div>
    </div>
  </button>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      hover: false,
      debounced: null
    };
  },
  methods: {
    click() {
      this.$router.push({
        name: "product-marketplace",
        params: { id: this.item.id }
      });
    },
    mouseenter() {
      if (window.innerWidth > 991) {
        this.debounced = setTimeout(() => {
          this.hover = true;
          this.$emit("mouseenter");
        }, 800);
      }
    },
    mouseleave() {
      clearTimeout(this.debounced);
      this.hover = false;
      this.$emit("mouseleave");
    }
  }
};
</script>
<style lang="scss" scoped>
.product-item {
  border: none;
  border-radius: 4px;
  width: 100%;
  height: 400px;
  background: #fff;
  box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.05);
  position: relative;
  color: #393444;
  transition: box-shadow 0.01s ease-in-out;

  &.hover {
    // box-shadow: 0px 0px 12px 8px rgba(0, 0, 0, 0.05);
  }

  img {
    height: 52%;
    min-height: 238px;
    width: 100%;
    object-fit: cover;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    border-radius: 4px 4px 0px 0px;
  }

  .container-info {
    padding: 10px;
    text-align: left;
    position: absolute;
    bottom: 0;
    width: 100%;
    margin-left: -0.4rem;

    font-size: 14px;
    i {
      font-size: 24px;
    }

    h5 {
      height: 30px;
      margin-bottom: 0;
      padding-bottom: 0;
      // padding-bottom: 15px;
    }
  }
}
</style>
